var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8507 8.14802V1.84035C27.8507 0.767358 26.9388 -0.0757073 25.866 0.000935C24.0423 0.131227 22.2568 0.376482 20.5097 0.729037C18.4561 1.15057 16.4484 1.71772 14.5174 2.4305C13.23 2.90568 11.9657 3.43451 10.7396 4.02466C8.90053 4.91371 7.13041 5.93305 5.45225 7.06736C4.33348 7.82612 3.25302 8.63086 2.21087 9.48926C1.98099 9.68086 1.7511 9.88013 1.52122 10.0717C0.708958 10.7768 0.655317 12.0108 1.41394 12.7695L5.88903 17.2455C6.56336 17.9199 7.6285 17.9659 8.35647 17.3604C13.2683 13.2371 19.4293 10.5469 26.1879 9.96444C27.1304 9.88013 27.8507 9.08305 27.8507 8.14035V8.14802Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector7);
export default __webpack_public_path__ + "static/media/Vector-7.5a516f54d1139a3fdfc630ded5daaca4.svg";
export { ForwardRef as ReactComponent };